// Lot R4 de design/os-reorganisation-ecrans (AGENT-796) : feuilles de
// Réglages d'Agent, feuille Web de l'Application, Espaces Run dans
// l'Application et état vide du Catalogue. Monté sous la clé `settings`.
// L'espagnol retombe sur le français (fallbackLng) tant qu'il n'est pas traduit ;
// les Espaces Run sont traduits (AGENT-868).
export const settingsResources = {
  fr: {
    connectors: {
      navLabel: 'Connecteurs',
      title: 'Connecteurs',
    },
    secrets: {
      navLabel: 'Secrets & variables',
      title: 'Secrets & variables',
      description:
        'Les secrets (clés, jetons) et les variables que l’Agent lit à l’exécution, avec une portée optionnelle par Workflow. La valeur d’un secret n’est jamais réaffichée.',
    },
    web: {
      navLabel: 'Web',
      title: 'Interface web',
      description:
        'Le frontend hébergé de l’Application : l’ouvrir avec votre session et activer une version préparée.',
      selectApplication: 'Sélectionnez une Application dans l’arbre Studio.',
      surfaceTitle: 'Surface publiée',
      surfacePublished: 'Surface publiée, version {{version}}.',
      surfaceMissing:
        'Aucune surface publiée : l’interface web ne peut pas s’ouvrir. Publiez la surface depuis la Revue.',
      openReview: 'Ouvrir la Revue',
      stateUnknown:
        'L’instance n’expose pas la version active du frontend : elle s’affiche ici après une activation.',
      openTitle: 'Ouvrir l’interface',
      openDescription:
        'Crée un lien à usage unique pour votre session ; aucun droit n’est ajouté.',
      openAction: 'Ouvrir l’interface',
      opening: 'Ouverture…',
      openedHint:
        'Le lien s’ouvre dans un nouvel onglet. S’il ne s’ouvre pas, utilisez-le dans les {{seconds}} secondes.',
      openLink: 'Lien d’ouverture',
      activateTitle: 'Activer une version',
      activateDescription:
        'L’agent de code prépare une version (maurice app frontend prepare). L’activation vérifie cette version, sonde le serveur et garde la version précédente en cas d’échec.',
      versionLabel: 'Version préparée',
      versionPlaceholder: 'ex. 1.2.0',
      activateAction: 'Activer',
      activating: 'Activation…',
      activated: 'Version {{version}} active.',
      activeVersion: 'Version active : {{version}}',
      activeUrl: 'Adresse : {{url}}',
      adminOnly:
        'L’activation est réservée aux administrateurs de l’organisation.',
      unavailable:
        'L’hébergement web des Applications n’est pas disponible sur cette instance : il est servi par One.',
      forbidden: 'Votre rôle ne permet pas cette action sur cette Application.',
      refused: 'Refusé : {{message}}',
      failed: 'Échec : {{message}}',
    },
    runSpaces: {
      navLabel: 'Espaces',
      title: 'Espaces',
      description:
        'Les espaces de travail des Agents de cette Application et leurs sessions.',
      searchLabel: 'Rechercher un espace ou une session',
      searchPlaceholder: 'Rechercher un espace ou une session…',
      selectApplication: 'Sélectionnez une Application.',
      empty: 'Aucun espace disponible pour cette Application.',
      noMatch: 'Aucun espace ni session ne correspond à « {{query}} ».',
      count: '{{count}} espace(s)',
      create: 'Nouvel espace',
      openSpace: 'Ouvrir l’espace',
      current: 'Espace courant',
      sessions: 'Sessions',
      shared: 'Partagée avec vous',
      sharedHint:
        'Vous avez été invité dans cette discussion seulement : les autres discussions de l’espace ne vous sont pas ouvertes.',
    },
    catalog: {
      surfaceOnly:
        'Seuls les Workflows publiés dans la surface de l’Application {{name}} apparaissent ici.',
      hidden:
        '{{count}} Workflow(s) actif(s) de l’Agent ne sont pas publiés dans cette surface.',
      surfaceMissing:
        'La surface de l’Application {{name}} n’est pas publiée : les Workflows actifs de l’Agent sont listés sans filtre.',
      openReview: 'Vérifier la surface dans la Revue',
    },
  },
  en: {
    connectors: {
      navLabel: 'Connectors',
      title: 'Connectors',
    },
    secrets: {
      navLabel: 'Secrets & variables',
      title: 'Secrets & variables',
      description:
        'Secrets (keys, tokens) and variables the Agent reads at run time, optionally scoped to a Workflow. A secret value is never shown again.',
    },
    web: {
      navLabel: 'Web',
      title: 'Web interface',
      description:
        'The Application’s hosted frontend: open it with your session and activate a prepared version.',
      selectApplication: 'Select an Application in the Studio tree.',
      surfaceTitle: 'Published surface',
      surfacePublished: 'Surface published, version {{version}}.',
      surfaceMissing:
        'No published surface: the web interface cannot open. Publish the surface from the Review.',
      openReview: 'Open the Review',
      stateUnknown:
        'This instance does not expose the active frontend version: it shows here after an activation.',
      openTitle: 'Open the interface',
      openDescription:
        'Creates a single-use link for your session; no right is added.',
      openAction: 'Open the interface',
      opening: 'Opening…',
      openedHint:
        'The link opens in a new tab. If it does not, use it within {{seconds}} seconds.',
      openLink: 'Opening link',
      activateTitle: 'Activate a version',
      activateDescription:
        'The coding agent prepares a version (maurice app frontend prepare). Activation checks that version, probes the server and keeps the previous version on failure.',
      versionLabel: 'Prepared version',
      versionPlaceholder: 'e.g. 1.2.0',
      activateAction: 'Activate',
      activating: 'Activating…',
      activated: 'Version {{version}} is active.',
      activeVersion: 'Active version: {{version}}',
      activeUrl: 'Address: {{url}}',
      adminOnly: 'Activation is limited to organization administrators.',
      unavailable:
        'Application web hosting is not available on this instance: One serves it.',
      forbidden: 'Your role does not allow this action on this Application.',
      refused: 'Refused: {{message}}',
      failed: 'Failed: {{message}}',
    },
    runSpaces: {
      navLabel: 'Spaces',
      title: 'Spaces',
      description:
        'The workspaces of this Application’s Agents and their sessions.',
      searchLabel: 'Search a space or a session',
      searchPlaceholder: 'Search a space or a session…',
      selectApplication: 'Select an Application.',
      empty: 'No space available for this Application.',
      noMatch: 'No space or session matches “{{query}}”.',
      count: '{{count}} space(s)',
      create: 'New space',
      openSpace: 'Open the space',
      current: 'Current space',
      sessions: 'Sessions',
      shared: 'Shared with you',
      sharedHint:
        'You were invited into this discussion only: the other discussions of the space are not open to you.',
    },
    catalog: {
      surfaceOnly:
        'Only the Workflows published in the surface of the {{name}} Application appear here.',
      hidden:
        '{{count}} active Workflow(s) of the Agent are not published in this surface.',
      surfaceMissing:
        'The surface of the {{name}} Application is not published: the Agent’s active Workflows are listed unfiltered.',
      openReview: 'Check the surface in the Review',
    },
  },
  es: {
    runSpaces: {
      navLabel: 'Espacios',
      title: 'Espacios',
      description:
        'Los espacios de trabajo de los Agentes de esta Application y sus sesiones.',
      searchLabel: 'Buscar un espacio o una sesión',
      searchPlaceholder: 'Buscar un espacio o una sesión…',
      selectApplication: 'Selecciona una Application.',
      empty: 'Ningún espacio disponible para esta Application.',
      noMatch: 'Ningún espacio ni sesión coincide con «{{query}}».',
      count: '{{count}} espacio(s)',
      create: 'Nuevo espacio',
      openSpace: 'Abrir el espacio',
      current: 'Espacio actual',
      sessions: 'Sesiones',
      shared: 'Compartida contigo',
      sharedHint:
        'Te invitaron solo a esta conversación: las demás conversaciones del espacio no están abiertas para ti.',
    },
  },
}
